"use strict";

module.exports = Object.freeze({
  ELEMENT_NODE: 1,
  ATTRIBUTE_NODE: 2, // historical
  TEXT_NODE: 3,
  CDATA_SECTION_NODE: 4, // historical
  ENTITY_REFERENCE_NODE: 5, // historical
  ENTITY_NODE: 6, // historical
  PROCESSING_INSTRUCTION_NODE: 7,
  COMMENT_NODE: 8,
  DOCUMENT_NODE: 9,
  DOCUMENT_TYPE_NODE: 10,
  DOCUMENT_FRAGMENT_NODE: 11,
  NOTATION_NODE: 12 // historical
});



//////////////////
// WEBPACK FOOTER
// ./~/jsdom/lib/jsdom/living/node-type.js
// module id = 70
// module chunks = 0